(function () {
    document.querySelectorAll('[data-clipboard-text]').forEach(function (element) {
        element.addEventListener('click', function (event) {
            const text = event.currentTarget.getAttribute('data-clipboard-text');
            navigator.clipboard.writeText(text);

            setTimeout(function () {
                $(element).tooltip('hide');
            }, 2000);
        });
    });
})();